import {
  Breadcrumb,
  Button,
  PageHeader,
  Table,
  Popconfirm,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { rackService } from "_services";
import PropTypes from "prop-types";
import { CloseOutlined } from "@ant-design/icons";

const List = ({ match }) => {
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    getRacks();
  }, []);

  const getRacks = () => {
    setLoading(true);
    rackService
      .getAll()
      .then((data) => {
        setItems(data.content);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Link to={`${path}/add`} key="btn-add">
        <Button>Add</Button>
      </Link>
    );
    return buttons;
  };

  const handleDelete = (id) => {
    rackService
      .delete(id)
      .then((x) => {
        message.success("Successfully deleted!");
        getRacks();
      })
      .catch((error) => {
        setError(error);
      });
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      render: (text, record) => (
        <Link to={`/racks/${record.id}/summary`}>{record.code}</Link>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => record.name ?? "",
    },
    {
      title: "Action",
      key: "action",
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Are you sure to delete this employee?"
          onConfirm={() => {
            handleDelete(record.id);
          }}
        >
          <CloseOutlined />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/racks">Racks</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            columns={columns}
            dataSource={items}
          />
        </Page>
      </PageHeader>
    </div>
  );
};

List.propTypes = {
  match: PropTypes.isRequired,
};

export default List;
